/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
// import Stepper from "src/shared/Stespper";
// eslint-disable-next-line import/no-unresolved
import DetailsHeading from "src/shared/DetailsHeading";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomStepper from "src/shared/CustomStepper";
import { showNewVersionUW } from "src/helpers/FormDetails/ProposalDetails/resources";
import GeneralDetails from "./GeneralDetails";
import Address from "./Address";
import Nominee from "./Nominee";
import MedicalAndLifestyle from "./MedicalAndLifestyle";
import CovidAndNri from "./Covid&NRI";
import MedicalAndLifeStyleV2 from "./MedicalAndLifeStyleV2";

// interface Props {
//   setParentStepNo: Dispatch<SetStateAction<number>>;
// }
function ProposerDetails() {
  const nationality = useAppSelector((state) => state.proposerDetails?.general?.nationalityCode);
  const primaryMembersData = useAppSelector((state) => state?.common?.leadDetails?.Members)?.filter(
    (e: any) => !e?.isJointMember
  )[0];
  const steps = [
    "General Details",
    "Address",
    "Nominee",
    "Medical & Lifestyle",
    ...(!["RES", ""].includes(nationality!) ? ["NRI Details"] : [])
  ];
  // const [stepNo, setStepNo] = useState(1);
  const proposerStepNumber = useAppSelector((state): any => state?.stepDetails?.proposerStepNo);

  const compType = () => {
    switch (proposerStepNumber) {
      case 1:
        return <GeneralDetails />;
      case 2:
        return <Address />;
      case 3:
        return <Nominee />;
      case 4:
        return showNewVersionUW(primaryMembersData) ? (
          <MedicalAndLifeStyleV2 />
        ) : (
          <MedicalAndLifestyle />
        );
      case 5:
        return nationality !== "RES" ? <CovidAndNri /> : <>default</>;
      default:
        return <>default</>;
    }
  };
  return (
    <div className="min-h-screen bg-whiteSmoke pt-8 pb-19.5 ">
      {/* <div className="w-290 bg-white pt-8.5 pb-10 mx-auto rounded-1.5xl"> */}
      <div className="xl:w-290 bg-white pt-8.5 pb-10 mx-auto rounded-1.5xl">
        <div className="pr-10 pl-10.25">
          <DetailsHeading label="Proposer Details" />
        </div>
        <CustomStepper
          steps={steps}
          currentStep={proposerStepNumber}
          stepperValue="proposer"
          // setStepNo={setStepNo}
          showBackArrow={false}
          leftSpacingClasses="w-8/100"
          rightSpacingClasses="w-68/1000"
          circleSizeClasses="h-6 w-6"
        />
        <div>{compType()}</div>
      </div>
    </div>
  );
}

export default ProposerDetails;
